import { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { validateDateCompleteness, validateDateLogic } from '../../contractor/hooks/DateHelpers';

export const useDateField = () => {
  const dispatch = useDispatch();
  const formValues = useSelector((state) => state.driver.formValues);
  
  const [fieldTouched, setFieldTouched] = useState({
    dia: false,
    mes: false,
    anio: false
  });
  
  const [dateError, setDateError] = useState('');

  const validateFechaCompleta = useCallback(() => {
    const { dia, mes, anio } = formValues;
    
    setDateError('');
    
    const hasEmptyField = (!dia && fieldTouched.dia) || (!mes && fieldTouched.mes) || (!anio && fieldTouched.anio);
    
    if (hasEmptyField) {
      setDateError('Ingresa tu fecha de nacimiento');
      dispatch({ type: 'driver/setValidValue', payload: { field: "fechaNacimiento", isValid: false } });
      return;
    }
    
    if (validateDateCompleteness(dia, mes, anio)) {
      if (!validateDateLogic(dia, mes, anio)) {
        setDateError('La fecha ingresada no es válida');
        dispatch({ type: 'driver/setValidValue', payload: { field: "fechaNacimiento", isValid: false } });
      } else {
        setDateError('');
        dispatch({ type: 'driver/setValidValue', payload: { field: "fechaNacimiento", isValid: true } });
      }
    } else {
      const allTouched = fieldTouched.dia && fieldTouched.mes && fieldTouched.anio;
      if (allTouched) {
        setDateError('Ingresa tu fecha de nacimiento');
      }
      dispatch({ type: 'driver/setValidValue', payload: { field: "fechaNacimiento", isValid: false } });
    }
  }, [formValues, fieldTouched, dispatch]);

  useEffect(() => {
    validateFechaCompleta();
  }, [validateFechaCompleta]);

  const handleDateChange = useCallback((field, value) => {
    dispatch({ type: 'driver/setFormValue', payload: { field, value } });

    const currentDay = field === "dia" ? value : formValues.dia || "";
    const currentMonth = field === "mes" ? value : formValues.mes || "";
    const currentYear = field === "anio" ? value : formValues.anio || "";

    if (currentDay && currentMonth && currentYear) {
      const formattedDate = `${currentYear}${currentMonth.padStart(2, "0")}${currentDay.padStart(2, "0")}`;
      dispatch({ 
        type: 'driver/setFormValue', 
        payload: { field: "fechaNacimiento", value: formattedDate } 
      });
    }
  }, [dispatch, formValues]);

  const createDateFieldHandler = useCallback((fieldName) => ({
    onChange: (e) => {
      const value = e.target.value;
      setFieldTouched(prev => ({ ...prev, [fieldName]: true }));
      handleDateChange(fieldName, value);
    },
    onBlur: () => setFieldTouched(prev => ({ ...prev, [fieldName]: true }))
  }), [handleDateChange]);

  const isDateFieldInvalid = useCallback((fieldName) => {
    const value = formValues[fieldName] || '';
    if (dateError === 'La fecha ingresada no es válida') {
      return true;
    }
    return !value && fieldTouched[fieldName];
  }, [formValues, fieldTouched, dateError]);

  return {
    dateError,
    fieldHandlers: {
      dia: createDateFieldHandler('dia'),
      mes: createDateFieldHandler('mes'),
      anio: createDateFieldHandler('anio')
    },
    isDateFieldInvalid
  };
};